import type { Quality } from './types';
import type { UrlParams } from './config';

export function detectQuality(params: UrlParams): Quality {
  const mq = (q: string) => (typeof matchMedia === 'function' ? matchMedia(q).matches : false);
  const reducedMotion = mq('(prefers-reduced-motion: reduce)');
  const touch = mq('(pointer: coarse)');
  const small = Math.min(innerWidth, innerHeight) < 640;
  const mem = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  const lowMem = typeof mem === 'number' && mem <= 2;
  const lite = params.lite ?? ((touch && small) || lowMem);
  return {
    tier: lite ? 'lite' : 'full',
    dprCap: lite ? 1.5 : 2,
    reducedMotion,
    touch,
  };
}
